import { supabase } from '@/integrations/supabase/client';
import {
  AgencyAdvisorMemberRow,
  AgencyDashboardOverviewResult,
  AgencyDashboardPeriod,
} from '@/integrations/supabase/rpc-types';

/**
 * Servizio per la dashboard agenzia (tab Panoramica + Advisor Members).
 * Le RPC fanno tutto il lavoro di aggregazione: il FE si limita a esporre i dati ricevuti.
 */
export class AgencyDashboardService {
  static async getOverview(
    period: AgencyDashboardPeriod = '30d'
  ): Promise<AgencyDashboardOverviewResult> {
    // RPC non ancora presente nei tipi generati (types.ts va rigenerato dopo il deploy
    // della migration) — stesso workaround già usato in useFullProfile.ts.
    const { data, error } = await supabase.rpc('get_agency_dashboard_overview' as any, {
      p_period: period,
    });

    if (error) {
      throw new Error(`Errore nel caricamento della panoramica: ${error.message}`);
    }

    return data as unknown as AgencyDashboardOverviewResult;
  }

  static async getAdvisorMembers(
    period: AgencyDashboardPeriod = '30d'
  ): Promise<AgencyAdvisorMemberRow[]> {
    const { data, error } = await supabase.rpc('get_agency_advisor_members' as any, {
      p_period: period,
    });

    if (error) {
      throw new Error(`Errore nel caricamento dei membri del team: ${error.message}`);
    }

    return (data ?? []) as unknown as AgencyAdvisorMemberRow[];
  }
}
